import { createFileRoute } from "@tanstack/react-router";
import ModuleCheckoutModal from "@/components/panel/ModuleCheckoutModal";

export const Route = createFileRoute("/test-modal")({
  component: TestModalPage,
});

function TestModalPage() {
  return (
    <div className="p-8">
      <ModuleCheckoutModal
        open={true}
        onOpenChange={() => {}}
        moduleKey="ia_automatizacion"
        moduleTitle="Integración IA"
        kind="addon"
        fallbackMonthlyCents={4900}
      />
    </div>
  );
}
